import { Model } from 'pinia-orm';
import User from './User';
import CalendarProfile from './CalendarProfile';

export default class Calendar extends Model {

    static get entity () {
        return 'calendars';
    }

    static fields () {
        return {
            id: this.uid(),
            calendar_profile_id: this.attr(null),
            provider_name: this.attr(null),
            profile_id: this.attr(null),
            profile_name: this.attr(null),
            calendar_id: this.attr(null),
            calendar_name: this.attr(null),
            calendar_readonly: this.attr(null),
            calendar_deleted: this.attr(null),
            calendar_primary: this.attr(null),
            calendar_integrated_conferencing_available: this.attr(null),
            permission_level: this.attr(null),

            calendar_profile: this.belongsTo(CalendarProfile, 'calendar_profile_id')
        }
    }

    get valid() {
        return !this.calendar_readonly && !this.calendar_deleted;
    }
}
